import React from 'react';

import { getEnv } from "../../../configuration/ConfigExpr"

class FooterCode extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){
        const { footerCode } = this.props;
        return(
            <div className="footer-code">
                <div className="footer-info-content">
                    {footerCode && footerCode.map(data => {
                        return (
                            <div className="footer-info-ico">
                                <img src={data.image}></img>
                                <span className="footer-info-content-cn">
                                    {data.title}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

export default FooterCode



// WEBPACK FOOTER //
// ./common/components/Footer/FooterCode.js